var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"live-icon relative"},[_c('div',[_c('img',{attrs:{"width":"25","height":"25"}})])])
}]

export { render, staticRenderFns }